// import { scan } from 'react-scan';
import { store } from '@/store/store';
import '@/styles/sns.scss';
import '@/styles/styles.scss';

import { Suspense, lazy, useEffect } from 'react';
import { hotjar } from 'react-hotjar';
import { Provider } from 'react-redux';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';

import * as Sentry from '@sentry/react';

import MainNavigator from './navigation/MainNavigator';

const Maintenance = lazy(() => import('./pages/Maintenance/Maintenance'));
const DomainRedirect = lazy(() => import('./pages/DomainRedirect/DomainRedirect'));

if (import.meta.env.VITE_ENV === 'production') {
	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		integrations: [
			// See docs for support of different versions of variation of react router
			// https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
			Sentry.reactRouterV6BrowserTracingIntegration({
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
				useEffect,
			}),
			Sentry.replayIntegration(),
			Sentry.extraErrorDataIntegration(),
		],

		environment: import.meta.env.VITE_ENV,

		// Performance tracing: tracesSampleRate is omitted to avoid consuming Sentry performance/transaction quota.
		// Set to e.g. 0.05 or 0.1 to enable when quota is allocated.
		// tracesSampleRate: 0.1,

		ignoreErrors: [/^Unable to preload CSS/],
		denyUrls: [/hotjar\.com/, /cdn\.jsdelivr\.net/, /googletagmanager\.com/i, /chrome-extension:\/\//i],

		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
	});

	hotjar.initialize({ id: 4967925, sv: 6 });
}

function App() {
	useEffect(() => {
		if (import.meta.env.VITE_ENV === 'production') {
			(function (c, l, a, r, i, t, y) {
				// @ts-expect-error script
				c[a] = // @ts-expect-error script
					c[a] ||
					function () {
						// @ts-expect-error script
						// eslint-disable-next-line prefer-rest-params
						(c[a].q = c[a].q || []).push(arguments);
					};
				// @ts-expect-error script
				t = l.createElement(r);
				// @ts-expect-error script
				t.async = 1;
				// @ts-expect-error script
				t.src = 'https://www.clarity.ms/tag/' + i;
				// @ts-expect-error script
				y = l.getElementsByTagName(r)[0];
				// @ts-expect-error script
				y.parentNode.insertBefore(t, y);
			})(window, document, 'clarity', 'script', 'sq5wshubkd');
		}
	}, []);

	const isLegacySnsDomain =
		typeof window !== 'undefined' &&
		(window.location.hostname === 'sns.sobrus.ovh' ||
			window.location.hostname === 'sns.sobrus.com' ||
			window.location.hostname.startsWith('sns.sobrus.'));

	if (isLegacySnsDomain) {
		return (
			<Suspense fallback={null}>
				<DomainRedirect />
			</Suspense>
		);
	}

	if (
		(import.meta.env.VITE_MAINTENANCE_MODE === 'ovh' && import.meta.env.VITE_ENV !== 'production') ||
		(import.meta.env.VITE_MAINTENANCE_MODE === 'prod' && import.meta.env.VITE_ENV === 'production')
	) {
		return (
			<Suspense fallback={null}>
				<Maintenance />
			</Suspense>
		);
	}

	return (
		<div className="App">
			<Provider store={store}>
				<MainNavigator />
			</Provider>
		</div>
	);
}

export default App;
